<template>
  <ThreeColumn :breadcrumbPaths="paths">
    <template v-slot:title>
      <h1 class="text-h1 mb-0" >{{$t('about.page_title')}}</h1>
    </template>

    <template v-slot:leftPanel>
      <TocWidget :toc="contentswdgt" />
    </template>

    <template v-slot:mainPanel>
      <v-divider class="mb-2"></v-divider>
      <v-row id="abtabout" class="pt-3 pb-12 px-3">

        <h2 class="text-h2 liiblack--text mb-4">{{$t('about.t_whatis')}}</h2>

        <!--logo-->
        <v-col cols="12" class="pt-0 pl-0">
          <v-img
            alt="HKLII Logo"
            class="mb-3"
            contain
            :src="require('../assets/HKLII_logo.svg')"
            min-width="70"
            max-width="170"
            :width="$vuetify.breakpoint.xs?'120px':'170px'" :height="$vuetify.breakpoint.xs?'62.71px':'88.84px'"
          /> 
        </v-col>

        <div>
          <i18n path="about.intro[0]" tag="p">
            <router-link :to="{name: 'home'}"> {{$t('home.fullname')}}</router-link>
            <a href="http://www.cs.hku.hk" target="_blank">{{$t('about.cs_dept')}}</a>
            <a href="http://www.hku.hk/law/" target="_blank">{{$t('about.law_fac')}}</a>
            <a href="http://www.austlii.edu.au/" target="_blank">AustLII</a>
          </i18n>
          <p>{{$t('about.intro[1]')}}</p>
          <p>{{$t('about.intro[2]')}}</p>
          <p>{{$t('about.intro[3]')}}</p>
        </div>
      </v-row>

      <v-divider class="mb-2"></v-divider>
      <v-row id="abtcontact" class="pt-3 pb-12 px-3">
        <v-col cols="12" class="pa-0">
          <h2 class="text-h2 liiblack--text mb-4">{{$t('btntxt.contactus')}}</h2>
        </v-col> 

        <div>
          <h3 class="text-h3 navlink--text">{{$t('about.law_fac2')}}</h3>
          <table><tbody>
            <tr>
              <td valign="top"><b>{{$t('about.addr_tag')}}</b></td>
              <td class="pl-4" v-html="$t('about.addr')"></td>
            </tr>
            <tr>
              <td><b>{{$t('about.email_tag')}}</b></td>
              <i18n path="about.email" tag="td" class="pl-4">
                <router-link :to="{name: 'feedback'}">{{$t('btntxt.feedback')}}</router-link>
              </i18n>
            </tr>
            <tr>
              <td><b>{{$t('about.website_tag')}}</b></td>
              <td class="pl-4">
                <a href="http://www.hku.hk/law" target="_blank">http://www.hku.hk/law</a>
              </td>
            </tr>
          </tbody></table>
        </div>

      </v-row>

      <v-divider class="mb-2"></v-divider>
      <v-row id="abtpersonnel" class="pt-3 pb-12 px-3">
        <h2 class="text-h2 liiblack--text mb-4">{{$t('about.t_personnel')}}</h2>
        <div>
          <i18n path="about.personnel[0]" tag="p">
            <a href="http://www.lawtech.hk/" target="_blank">{{$t('about.law_and_tech')}}</a>
            <a href="http://www.cs.hku.hk/" target="_blank">{{$t('about.cs_dept')}}</a>
            <a href="http://www.hku.hk/law/" target="_blank">{{$t('about.law_fac')}}</a>
            <a href="http://www.hku.hk/" target="_blank">{{$t('about.uni')}}</a>
            <a href="http://www.austlii.edu.au/" target="_blank">{{$t('legal.austlii')}}</a>
          </i18n>
          <i18n path="about.personnel[1]" tag="p">
            <router-link :to="{name: 'feedback'}">{{$t('btntxt.feedback')}}</router-link>
          </i18n>
            
          <h3 class="text-h3 navlink--text mt-8">{{$t('about.management_tag')}}</h3>
          <div v-for="(p, id) in staff.management" :key="'management_' + id">
            <p class="person">{{p.name}}</p>
            <p v-html="p.ent[$i18n.locale]" class="mb-0"></p>
            <p>
              <v-icon small color="darkgrey" class="mr-4"> mdi-web </v-icon><a :href="p.website">{{p.website}}</a><br />
              <v-icon small color="darkgrey" class="mr-4"> mdi-email-outline </v-icon> {{p.email}}
            </p>
          </div>

          <h3 class="text-h3 navlink--text mt-8">{{$t('about.staff_tag')}}</h3>
          <div v-for="(p, id) in staff.staff" :key="'staff_' + id">
            <p class="person">{{p.name}}<span class="ptitle">{{`(${p.title[$i18n.locale]})`}}</span></p>
            <p v-html="p.ent[$i18n.locale]" class="mb-0"></p>
            <p>
              <v-icon small color="darkgrey" class="mr-4"> mdi-email-outline </v-icon> {{p.email}}
            </p>
          </div>                                      
        </div>

      </v-row>

      <v-divider class="mb-2"></v-divider>
      <v-row id="abtassistance" class="pt-3 pb-12 px-3">
        <h2 class="text-h2 liiblack--text mb-4">{{$t('about.t_assist')}}</h2>
        <div>

          <h3 class="text-h3 navlink--text">{{$t('about.providers_tag')}}</h3>
          <p>{{$t('about.providers[0]')}}</p>
          <ul class="pb-3">
            <li v-for="(provider, idx) in $t('about.provider_ents')" :key="'provider' + idx">
              {{provider}}
            </li>
          </ul>
          <p>{{$t('about.providers[1]')}}</p>

          <h3 class="text-h3 navlink--text mt-8">{{$t('about.grants_tag')}}</h3>
          <p>{{$t('about.grants[0]')}}</p>
          <i18n path="about.grants[1]" tag="p">
            <router-link :to="{name: 'about', hash: '#abtpersonnel'}">{{$t('about.t_personnel')}}</router-link>
            <router-link :to="{name: 'about', hash: '#abtcontact'}">{{$t('btntxt.contactus')}}</router-link>
          </i18n>

          <h3 class="text-h3 navlink--text mt-8">{{$t('about.thanks_tag')}}</h3>
          <p>{{$t('about.thanks[0]')}}</p>
        </div>

      </v-row>
    </template>
  </ThreeColumn>
</template>

<script>
  import ThreeColumn from '@/components/applayout/ThreeColumn'
  import TocWidget from '@/components/TocWidget'
  import staff from '@/data/staff'
  export default {
    name: 'About',
    components: {
      ThreeColumn,
      TocWidget
    },
    data(){
      return {
        staff: staff
      }
    },
    /*watch: {
      '$i18n.locale': function(){
        window.document.title = `${this.$i18n.t('about.page_title')} | HKLII`
      }
    },*/
    computed:{
      contentswdgt(){
        return [
          {'title':this.$i18n.t('about.t_whatis'), id:'abtabout'},
          {'title':this.$i18n.t('btntxt.contactus'), id:'abtcontact'},
          {'title':this.$i18n.t('about.t_personnel'), id:'abtpersonnel'},
          {'title':this.$i18n.t('about.t_assist'), id:'abtassistance'},
        ]
      },
      paths(){
        return [
          {text: 'HKLII', disabled: false, href: {name: 'home'}},
          {text: this.$i18n.t('about.page_title'), disabled: true}
        ]
      }
    },
    /*mounted(){
      window.document.title = `${this.$i18n.t('about.page_title')} | HKLII`
    },*/
    metaInfo(){
      return{
        title: this.$i18n.t('about.page_title'),
         meta: [
          {
            name: 'description',
            content: "The Hong Kong Legal Information Institute (HKLII - pronounced 'H K Lee') provides free access to Hong Kong's legal information and documents.",
          }
        ],
      }
    }
  }
</script>
<style scoped lang="scss">
  @import '@/sass/_typography.scss';

  td {
    padding-right: 10px;
    padding-bottom: 10px;
  }
  
  a {
    @include link-no-underline;
  }

  .bulletp { /* for longer A1. items */
    text-indent: -2em;
    padding-left: 2em;
  }

  .bulletps { /* for shorter (a) items */
    text-indent: -1.5em;
    padding-left: 1.5em;
  }

  .person {
    font-size: 12.5pt;
    font-weight: 700;
    margin-bottom: 0px;
  }

  .ptitle {
    color: var(--v-navlink-base);;
    font-size: 11pt;
    margin-left: 10px;
    font-weight: 400;
  }

</style>
